import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';

import { ReactComponent as HourglassIcon } from 'src/assets/svgs/hourglass.svg';

import { buttonClassName, TestID } from './constants';

export interface Props {
  scheduledDurationInMinutes: number;
}

const ScheduledDurationDisplay: React.FC<Props> = ({ scheduledDurationInMinutes }) => {
  return (
    <button data-testid={TestID} className={buttonClassName} disabled aria-disabled>
      <HourglassIcon fontSize="20px" />

      <p className="grow-1 px-2">{`${scheduledDurationInMinutes} minutes`}</p>
    </button>
  );
};

export default ScheduledDurationDisplay;
